import View from '../../View';

/**
 * ArticleFilter
 */
class ArticleFilter extends View {
    constructor (node) {
        super(node);

        this.rubricInput = this.node.querySelector('#articleRubric');
        this.limitInput = this.node.querySelector('#articleLimit');

        this.rubricInput.addEventListener('change', this.inputChangeHandler);
        this.limitInput.addEventListener('change', this.inputChangeHandler);
    }

    /**
     * Submit the form when a filter has changed
     * @param e
     */
    inputChangeHandler = (e) => {
        this.node.submit();
    }
}

export default ArticleFilter;



// WEBPACK FOOTER //
// frontend/js/components/article/ArticleFilter.js